import { render, staticRenderFns } from "./BLanguage.vue?vue&type=template&id=dd6d8040&scoped=true"
import script from "./BLanguage.vue?vue&type=script&lang=js"
export * from "./BLanguage.vue?vue&type=script&lang=js"
import style0 from "./BLanguage.vue?vue&type=style&index=0&id=dd6d8040&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6d8040",
  null
  
)

export default component.exports